/**
 * getSiteSectionId - Returns a properly formatted string representing the site section id for BrightCove Player
 *
 * @param {string} platformType - String parameter representing the platform (i.e. android, ios, unknown)
 * @param {string}   deviceType - String parameter representing the device type (i.e. desktop, tablet, handset)
 * @param {string}   contentType - String parameter representing the content type (i.e. clips, vod)
 * @param {string}   rootName - Optional string parameter representing the root name assignment for the SSID; defaults to `watchespn`
 *
 * @return {string} - Concatenated string value generated by platform type, device type and content type.
 */
export default function getSiteSectionId(platformType = '', deviceType, contentType, rootName) {
    let ssid = (typeof rootName === 'string' && rootName !== '') ? rootName : 'watchespn';

    // Client side user-agent detection is used for platformType;
    // unknown is the default assignment when no matches are found
    if (platformType !== '' && platformType !== 'unknown') {
        ssid = `${ssid}:${platformType}`;
    }

    if (typeof deviceType === 'string' && deviceType !== '') {
        ssid = `${ssid}:${deviceType}`;
    }

    if (typeof contentType === 'string' && contentType !== '') {
        ssid = `${ssid}:${contentType}`;
    }

    return ssid;
}



// WEBPACK FOOTER //
// ./app/lib/util/getSiteSectionId.js